/**
 * HTML-style pattern strings shared by the form editor palette and persistence round-trip.
 */
export const PALETTE_EMAIL_PATTERN = "^[^\\s@]+@[^\\s@]+\\.[^\\s@]+$";
export const PALETTE_URL_PATTERN = "^https?:\\/\\/.+";
